import { ForwardedRef, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { Icon, IconProps } from '../../components/Icon/Icon'
import { faChevronLeft } from '../../icons/regular'
import definePrimitive from '../../util/definePrimitive'

const Root = definePrimitive({
  name: 'PageHeader',
  element: 'header',
  className: twMerge(
    'grid content-center items-center [grid-area:page-header] [grid-template-areas:"back_back""title_actions"] [grid-template-columns:1fr_auto]'
  )
})

const Title = definePrimitive({
  name: 'PageHeaderTitle',
  element: 'h1',
  className: twMerge(
    'typo-display-small row-start-2 row-end-2 flex items-center justify-start gap-4 [grid-area:title]'
  )
})

const Actions = definePrimitive({
  name: 'PageHeaderActions',
  element: 'h1',
  className: twMerge(
    'typo-display-small row-start-2 row-end-2 flex items-center justify-start gap-4 [grid-area:actions]'
  )
})

const Back = definePrimitive({
  name: 'PageHeaderBack',
  element: 'h1',
  className: twMerge(
    'typo-body-medium mb-2 flex items-center text-gray-600 [grid-area:back]'
  )
})

const BackIcon = forwardRef(
  function PageHeaderBackIcon (props: Omit<IconProps, 'size' | 'icon'>, ref: ForwardedRef<SVGSVGElement>) {
    return (
      <Icon
        {...props}
        ref={ref}
        size='xs'
        icon={faChevronLeft}
        className={twMerge('mr-2 inline-block text-gray-600', props.className)}
      />
    )
  }
)

export {
  Root,
  Title,
  BackIcon,
  Actions,
  Back
}
